import React, { useState, useEffect, useCallback } from "react";
import { Typography, Box, Grid2, Button, FormControl, RadioGroup, Radio, FormControlLabel, TextField, Switch } from "@mui/material";
import axios from 'axios';

export default function DeleteSubmission({organization, subType, fileName, email, onCloseDelete, actionSubmitted}) {
    const serverHost = process.env.REACT_APP_BACKEND_SERVER_HOST || 'https://localhost:3001';
    const [reason, setReason] = useState("");
    const [confirm, setConfirm] = useState("");
    const [submissionDetail, setSubmissionDetail] = useState("");
    const [dataSend, setDataSend] = useState({
        reason: '',
        reason_text: '',
        reply_to_submitter: false
    });

    const handleReasonChange = (event) => {
        setReason(event.target.value);
        setDataSend((prevState) => {
            return{
                ...prevState,
                reason: event.target.value,
                reason_text: event.target.value,
            }
        })
    }

    const handleReplySubmitter = (event) => {
        setDataSend((prevState) => {
            return{
                ...prevState,
                reply_to_submitter: event.target.checked,
            }
        })
    }

    const fetchSubmissionDetails = useCallback(async () => {
        try {
          const fileNameEscaped = encodeURIComponent(fileName);
          const response = await axios.get(`${serverHost}/submissions/${email}/${fileNameEscaped}/details`, { withCredentials: true });
          if (response.status === 200) {
              setSubmissionDetail(response.data.details);
          }
        } catch (error) {
          console.error('Error fetching submissions:', error.response ? error.response.data : error.message);
        }
      }, [serverHost, email, fileName]);

      const deleteSubmission = useCallback(async () => {
        try {
            const fileNameEscaped = encodeURIComponent(fileName);
            const response = await axios.post(`${serverHost}/submissions/${email}/${fileNameEscaped}/delete`, dataSend, { withCredentials: true });
            if (response.status === 204) {
                actionSubmitted('deleted');
                onCloseDelete();
            }
            } catch (error) {
                actionSubmitted(false);
                console.error('Error fetching submissions:', error.response ? error.response.data : error.message);
                onCloseDelete();
            }
        }, [serverHost, dataSend, fileName, email, actionSubmitted, onCloseDelete]);

      const changeTrack = {
        'dataset': 'Dataset',
        'track1':  'Document Validation',
        'track2':  'Match to ID',
        'track3':  'Passive PAD'
      }

      const changeTypeName = (typeName) => {
        return changeTrack[typeName] || typeName; 
       }

      useEffect(() => {
          fetchSubmissionDetails();
        }, [fetchSubmissionDetails, dataSend]);

    return(
        <Box className="modal-container">
        <Box className="modal-box1">
            <Typography className="modal-header">DELETE SUBMISSION</Typography>
            <Grid2 container spacing={2} rowSpacing={0} sx={{marginTop: '10px'}} className="submission-display-flex">
                <Grid2 item size={3}>
                    <Typography className="modal-sub-header">Organization</Typography>
                </Grid2>
                <Grid2 item size={3}>
                    <Typography className="modal-sub-header">Submission Type</Typography>
                </Grid2>
                <Grid2 item size={3}>
                    <Typography className="modal-sub-header">File Name</Typography>
                </Grid2>
                <Grid2 item size={3} />
                <Grid2 item size={3}>
                    <Typography className="modal-description">{organization}</Typography>
                </Grid2>
                <Grid2 item size={3}>
                    <Typography className="modal-description">{changeTypeName(subType)}</Typography>
                </Grid2>
                <Grid2 item size={6}>
                    <Typography className="modal-description">{fileName.split('/').reverse()[0]}</Typography>
                </Grid2>
            </Grid2>
            <Grid2 container spacing={2} rowSpacing={0} sx={{marginTop: '10px'}} className="submission-display-block">
                <Grid2 item size={12}>
                    <Typography className="modal-sub-header">Organization</Typography>
                </Grid2>
                <Grid2 item size={12} sx={{marginBottom: '10px'}}>
                    <Typography className="modal-description">{organization}</Typography>
                </Grid2>
                <Grid2 item size={12}>
                    <Typography className="modal-sub-header">Submission Type</Typography>
                </Grid2>
                <Grid2 item size={12} sx={{marginBottom: '10px'}}>
                    <Typography className="modal-description">{changeTypeName(subType)}</Typography>
                </Grid2>
                <Grid2 item size={12}>
                    <Typography className="modal-sub-header">File Name</Typography>
                </Grid2>
                <Grid2 item size={12}>
                    <Typography className="modal-description">{fileName.split('/').reverse()[0]}</Typography>
                </Grid2>
            </Grid2>
        </Box>
        <Box className="modal-box3">
            <Typography className="modal-sub-header">Submission History</Typography>
            <Box className='modal-submission-history2'>
                <Typography className="submission-history-text">
                    {submissionDetail}
                </Typography>
            </Box>
        </Box>
        <Box className='modal-reason'>
            <Typography className="modal-sub-header">Delete Reason (Required)</Typography>
            <FormControl>
                <RadioGroup value={reason} onChange={handleReasonChange}>
                    <FormControlLabel value='Test dataset/docker' control={<Radio className='reason-radio-standard' />} label={<Typography className="modal-description">Test dataset/docker</Typography>} />
                    <FormControlLabel value='Resubmitted data/docker' control={<Radio className='reason-radio-standard' />} label={<Typography className="modal-description">Resubmitted data/docker</Typography>} />
                    <FormControlLabel value='Submission withdrawn' control={<Radio className='reason-radio-standard' />} label={<Typography className="modal-description">Submission withdrawn</Typography>} />
                </RadioGroup>
            </FormControl>
        </Box>
        <Box className='modal-request'>
            <Typography className="modal-sub-header">
                Are you sure you want to delete?
            </Typography>
            <Grid2 container className='confirm-containers'>
                <Grid2 item size="grow">
                    <TextField 
                        className='modal-box4'
                        slotProps={{input: {style: {fontSize: '12px', height: '40px'}}}}
                        placeholder='Type "Delete" to proceed' 
                        onChange={(event) => {
                            setConfirm(event.target.value);
                        }}
                    />
                </Grid2>
                <Grid2 item sx={{width: '40px'}} />
                <Grid2 item size="grow">
                    <Box display='flex' sx={{flexDirection: 'row', justifyContent: 'space-around'}} className='modal-box4'>
                        <Box sx={{display: 'flex', alignItems: 'center'}}>
                            <Typography className="modal-description">Reply to submitter</Typography>
                        </Box>
                        <Box>
                            <Switch onChange={handleReplySubmitter} />
                        </Box>
                    </Box>
                </Grid2>
            </Grid2>
            <Box className='action-buttons-container'>
                <Button onClick={deleteSubmission} disabled={confirm === 'Delete' && reason !== "" ? false : true} sx={{width: '210px', marginRight: '40px'}} variant="outlined" className="action-buttons">DELETE</Button>                
                <Button onClick={onCloseDelete} sx={{width: '210px'}} variant="outlined" className="action-buttons">CANCEL</Button>
            </Box>
        </Box>
    </Box>
    )
}